import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from 'reactstrap';
import PaymentPayExtraComponent from '../components/payExtra';
import { t } from 'i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { TOrder } from '../../../../lib/utils/types';
import { useInjection } from 'brandi-react';
import { calculateSubscriptionBalance, normalizeCurrency } from '../../../../lib/utils/helpers';
import { PayBlockModelStoreToken } from '../models/PayBlockModel/index.model';
import { usePublicEndpoints } from 'lib/api/usePublicEndpoints';
import {observer} from "mobx-react-lite";

interface IPaymentMethodAbonementComponentProps {
  order: TOrder,
}

const PaymentMethodAbonementComponent: FC<IPaymentMethodAbonementComponentProps> = (props) => {
  const {
    order,
  } = props;

  const { getCurrencies } = usePublicEndpoints();
  const payBlockModel = useInjection(PayBlockModelStoreToken);
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    getCurrencies()
        .then(res => setCurrencies(res));
  }, [])

  const history = useHistory();
  const { pathname } = useLocation();

  const onBuy = useCallback(() => {
    history.push(`/abonement?redirectURL=${pathname}&redirectOrderId=${order?.id}`);
  }, []);

  const subBalance = useMemo(() => calculateSubscriptionBalance(payBlockModel.subscription.value?.subscriptionCurrentValue, payBlockModel.subscription.value?.discountedPrice, true), [payBlockModel.subscription.value]);
  const success = useMemo(() => +subBalance >= 0, [subBalance]);
  const currency = useMemo(() => order?.priceCurrency && normalizeCurrency(order.priceCurrency, currencies), [order?.priceCurrency, currencies])

  if (order?.hasPaid) {
    return null;
  }

  return (
    <div className='payment-block'>
      <div className='title-label'>{t('paymentPay.subscription')}</div>
      {payBlockModel.subscription.value && payBlockModel.subscription.value.subscriptionCurrentValue > 0 ?
        <>
          <table className='mt-3'>
            <tbody>
            <tr>
              <td className='font-weight-bold pb-2 pr-5'>{t('subscriptions.balance')}:</td>
              <td className='pb-2'>{payBlockModel.subscription.value?.subscriptionCurrentValue}&nbsp;{currency}</td>
            </tr>
            <tr>
              <td className='font-weight-bold pb-2 pr-5'>{t('common.discount')}:</td>
              <td className='pb-2'>
                {payBlockModel.subscription.value?.discountValue}%&nbsp;({(order?.totalValue - payBlockModel.subscription.value?.discountedPrice)?.toFixed(2)}&nbsp;{currency})</td>
            </tr>
            <tr>
            <td className='font-weight-bold pb-2 pr-5'>{t('paymentPay.remainder.sub')}:</td>
               <td className={`pb-2 ${success ? 'text-success' : 'text-danger'}`} >{subBalance > 0 ? subBalance : 0}&nbsp;{currency}</td>
            </tr>
            {(subBalance < 0) && <tr>
              <td className='font-weight-bold pb-2 pr-5'>{t('paymentPay.remainder.subToPayment')}:</td>
              <td className='pb-2' >{Math.abs(subBalance || 0)}&nbsp;{currency}</td>
            </tr>}
            </tbody>
          </table>
        </>
      : <div className='d-flex align-items-center'>
          <span>{t('paymentPay.noneActiveSub')}</span>
          <Button
            color={'primary'}
            type={'button'}
            className={'form-button mt-0'}
            onClick={onBuy}
          >
            {t('common.buy')}
          </Button>
        </div>}
      {!success && <>
        <div className='payment-divider' />
        <PaymentPayExtraComponent />
      </>}
    </div>
  )
}

export default observer(PaymentMethodAbonementComponent);